import React from 'react';
import { useSelector } from 'react-redux';
import ExpandableText from '../../../components/UI/ExpandableText';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { classes } from '../../../utils/commonUtils';
import { DetailsBadge } from '../details-badge/details-badge';
import { DetailsSpacing } from '../details-spacing/details-spacing';
import { InfoLine, TitleInfoLine } from '../info-line/info-line';
import { FocusedAsset } from '../use-focused-asset';
import { DetailsButtons } from './details-buttons';
import css from './details-header.module.scss';
import { DetailsSubtitle } from './details-subtitle';

interface DetailsHeaderProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: Source;
}

export function DetailsHeader({ asset, source, focusedAsset }: DetailsHeaderProps) {
  const background = useSelector((state) => state.router.background);

  return (
    <DetailsSpacing>
      <header className={classes(css.header, background && css.withBackground)}>
        <div className={css.badges}>
          <DetailsBadge asset={asset} source={source} />
        </div>

        <div className={classes(css.titles, asset.type !== 'episode' && css.withoutSubtitle)}>
          {asset.type === 'episode' && <DetailsSubtitle asset={asset} source={source} />}
          <h1 className={css.title}>{asset.titleName}</h1>
          <TitleInfoLine className={css.infoLine} asset={asset} source={source} />
        </div>

        <DetailsButtons asset={asset} focusedAsset={focusedAsset} source={source} />

        <ExpandableText className={css.description} threshold={275}>
          {asset.descriptionLong || asset.descriptionShort}
        </ExpandableText>
      </header>
    </DetailsSpacing>
  );
}

export function DetailsHeaderSkeleton() {
  const background = useSelector((state) => state.router.background);

  return (
    <DetailsSpacing>
      <header className={classes(css.header, background && css.withBackground)}>
        <div className={css.titles}>
          <div className={classes(css.title, css.skeleton)} />
          <InfoLine.Skeleton />
        </div>

        <DetailsButtons.Skeleton />

        <div className={classes(css.description, css.skeleton)} />
      </header>
    </DetailsSpacing>
  );
}

DetailsHeader.Skeleton = DetailsHeaderSkeleton;
